import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useNavigate } from 'react-router-dom';
import { useSentimentAnalysisApi } from '../../store/api/hooks/sentimentAnalysisApiHook';
import { useAuthStatus, useStoreSelector, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { toast } from 'react-hot-toast';
import moment from 'moment';
import { SentimentBreakdownProps } from '../../_config/interfaces/interfaces';


const SentimentBreakdown: React.FC<SentimentBreakdownProps> = ({ filterValue }) => {
    const [sentimentBreakdown, setSentimentBreakdown] = useState<any[]>([]);
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);

    const sentimentAPI: any = useSentimentAnalysisApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const branchDS = useStoreBrnDSSelector();
    // console.log('useEffect =>', branchDS);

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue);
        } else {
            getSentimentBreakdown({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        getSentimentBreakdown(filterValue);
    }
    const getSentimentBreakdown = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, ...param };
        } else {
            params = { branch_id: branchDS?.branch_id };
        }
        // console.log('params =>', params);
        try {
            setTimeout(() => {
                sentimentAPI.getSentimentBreakdown(params, (msg: any, resp: any) => {
                    // console.log('response =>', resp, msg);
                    setSentimentBreakdown(resp.data);
                }, (err: any) => {
                    toast.error(err);
                })
                setOnSubmitLoading(false);
            }, 3000);
        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    }

    const transformedData = sentimentBreakdown.map(item => ({
        sentiment: item.sentiment,
        positive: item.sentiment === 'positive' ? item.percentage : 0,
        negative: item.sentiment === 'negative' ? item.percentage : 0,
        mixed: item.sentiment === 'mixed' ? item.percentage : 0,
        neutral: item.sentiment === 'neutral' ? item.percentage : 0,
    }));


    const getFillColor = (sentiment: string) => {
        switch (sentiment) {
            case 'positive':
                return '#82ca9d';
            case 'negative':
                return '#f87171';
            case 'mixed':
                return '#9ca3af';
            case 'neutral':
                return '#EED202';
            default:
                return '#8884d8';
        }
    };
    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart width={500} height={300}
                data={transformedData}
                margin={{
                    top: 20,
                    // right: 30,
                    // left: 20,
                    bottom: 5,
                }}
            // barGap={5}
            // barCategoryGap="5%"
            >
                <CartesianGrid vertical={false} strokeDasharray="3 3" />
                <XAxis
                    dataKey="sentiment"
                    tickFormatter={(value) => value.charAt(0).toUpperCase() + value.slice(1)}
                    tickCount={3}
                />
                <YAxis
                    tickFormatter={(value) => `${Math.floor(value)}%`}
                    domain={[0, 100]}
                    tickCount={3}
                />
                <Tooltip cursor={{ fill: 'rgba(148, 163, 184, 0.14)' }} />
                <Legend />
                <Bar
                    dataKey="positive"
                    fill={getFillColor('positive')}
                    name="Positive"
                    stackId="a"
                    barSize={100}
                />

                <Bar
                    dataKey="negative"
                    fill={getFillColor('negative')}
                    name="Negative"
                    stackId="a"
                    barSize={100}
                />

                <Bar
                    dataKey="mixed"
                    fill={getFillColor('mixed')}
                    name="Mixed"
                    stackId="a"
                    barSize={100}
                />

                <Bar
                    dataKey="neutral"
                    fill={getFillColor('neutral')}
                    name="Neutral"
                    stackId="a"
                    barSize={100}
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default SentimentBreakdown;
